import xmljs from 'xml-js';
import { colorMapper } from './colorset';
import { Layer } from '../components/ConfigPanel';
import { ItemSchemas, ColorSchema, GlobalColors } from '../assets';

function mapAttrs(
  attrs: Record<string, string>,
  map: Record<string, Record<string, string>>
) {
  const mapped = Object.entries(attrs).map(([k, v]): [string, string] => {
    if (k in map) return [k, map[k][v] || v];
    return [k, v];
  });
  return Object.fromEntries(mapped);
}

export function recolor(
  svg: xmljs.Element | xmljs.ElementCompact,
  schema: ColorSchema[],
  colors: string[]
): xmljs.Element | xmljs.ElementCompact {
  let attributes =
    svg.attributes &&
    // TODO: sourceColors should be constructed from layer sources eventually
    mapAttrs(svg.attributes, { fill: colorMapper(schema, colors) });
  let elements =
    svg.elements &&
    (svg.elements as xmljs.Element[]).map(e => recolor(e, schema, colors));
  return {
    ...svg,
    attributes,
    elements,
  };
}

export function loadSVGs(
  layers: Layer[],
  globalColors: string[]
): Promise<string[]> {
  return Promise.all(
    layers
      .map(layer => ({ layer, schema: ItemSchemas[layer.item] }))
      .map(l =>
        // TODO: cache
        fetch(l.schema.url)
          .then(response => response.text())
          .then(svg => {
            let obj = xmljs.xml2js(svg);
            const newObj = recolor(
              obj,
              l.schema.colors.concat(GlobalColors.colors),
              l.layer.colors.concat(globalColors)
            );
            return xmljs.js2xml(newObj);
          })
      )
  );
}
